export default function preloaderGame8 (scene) {

    scene.load.image(`tilesgame8`, `/tiles/game8.png`);
    // scene.load.image(`brokenMask1`, `/img/game8/broken-mask-1.png`);
    // scene.load.image(`brokenMask2`, `/img/game8/broken-mask-2.png`);
    // scene.load.image(`brokenMask3`, `/img/game8/broken-mask-3.png`);
    // scene.load.image(`brokenMask4`, `/img/game8/broken-mask-4.png`);

	scene.load.audio("screamSong", ["/audio/songs/8-scream.mp3"]);

	scene.load.spritesheet(`jiu-game8`, 
		`/img/game8/jiu.png`,
		{ frameWidth: 27, frameHeight: 37}
	);

	scene.load.spritesheet(`sua-game8`, 
		`/img/game8/sua.png`,
		{ frameWidth: 25, frameHeight: 37}
	);

	scene.load.spritesheet(`siyeon-game8`, 
		`/img/game8/siyeon.png`,
		{ frameWidth: 27, frameHeight: 37}
	);
	
	scene.load.spritesheet(`handong-game8`, 
		`/img/game8/handong.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`yoohyeon-game8`, 
		`/img/game8/yoohyeon.png`,
		{ frameWidth: 25, frameHeight: 37}
	);

	scene.load.spritesheet(`dami-game8`, 
		`/img/game8/dami.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`gahyeon-game8`,
		`/img/game8/gahyeon.png`,
		{ frameWidth: 25, frameHeight: 37}
	);	
	
	scene.load.spritesheet(`enemy-game8`,
		`/img/game8/enemy.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`humo-game8`, 
		`/img/generalSprites/humo-big.png`,
		{ frameWidth: 41, frameHeight: 42}
	);	
	
	scene.load.spritesheet(`brokenMask1`, 
		`/img/game8/broken-mask-1.png`,
		{ frameWidth: 9, frameHeight: 9}
	);
	
	scene.load.spritesheet(`brokenMask2`, 
		`/img/game8/broken-mask-2.png`,
		{ frameWidth: 9, frameHeight: 9}
	);scene.load.spritesheet(`brokenMask3`, 
		`/img/game8/broken-mask-3.png`,
		{ frameWidth: 9, frameHeight: 9}
	);scene.load.spritesheet(`brokenMask4`, 
		`/img/game8/broken-mask-4.png`,
		{ frameWidth: 9, frameHeight: 9}
	);scene.load.spritesheet(`fullMask`, 
		`/img/game8/full-mask.png`,
		{ frameWidth: 17, frameHeight: 17}
	);

	scene.load.tilemapTiledJSON(`game8`, `/tiles/game8.tmj`);

}